function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.153,4485.74c-2.509,2.3-2.875,2.032-5.132-.066-3.492-3.246.3-6.766,2.447-4.034a.2.2,0,0,0,.311,0C39.9,4478.925,43.795,4482.4,40.153,4485.74ZM37.642,4499.2a1,1,0,0,1-1,1.133h0a.99.99,0,0,1-.981-.853,6.082,6.082,0,0,0-5.9-5.245c-.014,0-.028,0-.042,0s-.028,0-.043,0a6.082,6.082,0,0,0-5.9,5.245.992.992,0,0,1-.982.853,1,1,0,0,1-1-1.133,8.121,8.121,0,0,1,4.9-6.372,4,4,0,1,1,6.052,0A8.123,8.123,0,0,1,37.642,4499.2Zm-5.921-8.961a2,2,0,1,0-2.043,2c.015,0,.028,0,.043,0l.042,0A2,2,0,0,0,31.721,4490.236Z",
  transform: "translate(-21.79 -4480.662)"
});

var SvgMenuTeam = function SvgMenuTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.858,
    height: 19.668,
    viewBox: "0 0 19.858 19.668",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-team.baeefa27.svg";
export { ForwardRef as ReactComponent };